import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import oitsActions from '../../store/oits/action-creators/index';
import oitsSelectors from '../../store/oits/selectors';
// import AddActionButton from '../common/AddActionButton';
import OitTaskTable from './OitTaskTable';

class OitTasksIndex extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.taskResponses) {
      return {
        ...prevState,
        taskResponses: nextProps.taskResponses,
      };
    }
    return { ...prevState };
  }
  constructor(props) {
    super(props);
    this.state = {
      filterByTaskGroup: 'all',
      filteredTaskResponses: this.props.taskResponses,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.match.params.oitGuid !== this.props.selectedOitGuid) {
      this.props.setSelectedOitGuid(this.props.match.params.oitGuid);
    }
    this.props.loadOitTasksIndex(this.props.match.params.oitGuid);
  }

  // ----------------------
  // Computed
  // ----------------------

  // get filterByGroupOptions() {
  //   return this.props.taskGroups.map(taskGroup => (
  //     <option value={taskGroup.name}>{taskGroup.name}</option>
  //   ));
  // }

  get isLoading() {
    return !this.props.selectedOit || this.props.isLoading;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">{this.props.selectedOit.getFullName()}</h4>
              {/*
              <AddActionButton
                label="Completed Task Item"
                onAdd={this.props.addTaskResponse}
              />
              */}
            </div>
            <div className="app-content">
              <OitTaskTable taskResponses={this.props.taskResponses} />
            </div>
          </Fragment>
        )}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    taskGroups: state.taskGroups.list,
    taskResponses: state.oits.taskResponses,
    selectedOit: oitsSelectors.selectedOit(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadOitTasksIndex: (oitGuid) => {
      return dispatch(oitsActions.loadOitTasksIndex(oitGuid));
    },
    setSelectedOitGuid: (oitGuid) => {
      return dispatch(oitsActions.setSelectedOitGuid(oitGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OitTasksIndex);
